/**
 * Fuente única de copy público. El precio se mantiene fuera de la landing hasta
 * que legal/fiscal habilite `isPublic`; el valor decidido permanece documentado
 * en el plan de producto, no en el HTML.
 */
export type AssistantOfferStatus = 'available' | 'beta' | 'coming_soon';

export const publicOffer = {
  isPublic: false,
  priceMxn: 219,
  assistantQueries: 60,
  queryReturnDays: 7,
  assistantStatus: 'available' as AssistantOfferStatus,
  available: [
    'Analiza tus registros y pregunta antes de comprar',
    'Registra ingresos y gastos con tus palabras',
    'Agrega compras de hoy o a meses que ya estabas pagando',
    'Configura tu primera tarjeta y registra pagos que ya hiciste',
    'Revisa cada cambio antes de confirmarlo',
  ],
  beta: [] as string[],
  comingSoon: [] as string[],
};
